export default __webpack_public_path__ + "static/media/show2.e362cdd6.jpeg";